import React from "react";
import { T } from "pages/Issue/theme";
import { rangeEmpty } from "helpers/dateRange";

// ─── Date range filter ────────────────────────────────────────────────────
//
// One control, four surfaces: Issues, Checklist, Schedule and the Review
// Center all filter by the same two questions, so they get the same two
// pairs of boxes rather than four dialects of the same idea.
//
//   "Started / created"  the day the row began    (startDate | createdAt)
//   "Ends / due"         the day it is owed by    (endDate   | dueDate)
//
// Native <input type="date"> on purpose. The Review Center's day filter is
// already one, the Scheduler and Checklist pages carry no date library, and
// IssuePage is on moment while antd 5's DatePicker is on dayjs — a picker
// component here would mean reconciling that on a toolbar that only needs
// two day strings. The native control also opens the OS date UI on mobile,
// which the toolbar variants do not.
//
// Both ends are optional and each constrains the other, so "from the 5th
// onwards" and "up to the 5th" are as expressible as a closed window.

const boxStyle = {
  // #d9d9d9, not T.line: matches the antd controls this sits between on
  // every toolbar. T.line (#EFEFEF) is a card divider and disappears
  // against a white field.
  border: "1px solid #d9d9d9",
  borderRadius: 6,
  padding: "3px 6px",
  fontSize: 13,
  color: T.ink,
  background: "#fff",
  height: 32,
};

export default function DateRangeFilter({
  label,
  value,
  onChange,
  title,
  size = "default",
}) {
  const from = (value && value.from) || "";
  const to = (value && value.to) || "";
  const set = (next) => onChange({ from, to, ...next });
  const box = size === "small" ? { ...boxStyle, height: 24, padding: "1px 4px", fontSize: 12 } : boxStyle;

  return (
    <span
      title={title}
      style={{ display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}
    >
      {label && (
        <span style={{ fontSize: 12, color: T.muted }}>{label}</span>
      )}
      <input
        type="date"
        aria-label={`${label || "Date"} from`}
        value={from}
        max={to || undefined}
        onChange={(e) => set({ from: e.target.value })}
        style={box}
      />
      <span style={{ color: T.muted }}>–</span>
      <input
        type="date"
        aria-label={`${label || "Date"} to`}
        value={to}
        min={from || undefined}
        onChange={(e) => set({ to: e.target.value })}
        style={box}
      />
      {!rangeEmpty(value) && (
        <a
          onClick={() => onChange({ from: "", to: "" })}
          title="Clear this range"
          style={{ color: T.muted, fontSize: 14, lineHeight: 1, padding: "0 2px", cursor: "pointer" }}
        >
          ×
        </a>
      )}
    </span>
  );
}
